import type { OnDestroy, OnInit } from '@angular/core';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CoreWebVitalsTracking } from './core-web-vitals-tracking.service';

@Component({
  standalone: false,
  selector: 'fl-core-web-vitals-tracking',
  template: ` <ng-container /> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CoreWebVitalsTrackingComponent implements OnDestroy, OnInit {
  private coreWebVitalsTracking = inject(CoreWebVitalsTracking);

  ngOnInit(): void {
    this.coreWebVitalsTracking.trackCoreWebVitalMetrics();
  }

  ngOnDestroy(): void {
    this.coreWebVitalsTracking.destroy();
  }
}
